/*

 * TotalStorage

 *

 * Copyright (c) 2012 Jared Novack & Upstatement (upstatement.com)

 * Dual licensed under the MIT and GPL licenses:

 * http://www.opensource.org/licenses/mit-license.php

 * http://www.gnu.org/licenses/gpl.html

 *

 * Total Storage is the conceptual the love child of jStorage by Andris Reinman,

 * and Cookie by Klaus Hartl -- though this is not connected to either project.

 *

 * @name $.totalStorage

 * @cat Plugins/Cookie

 * @author Jared Novack/jared@upstatement.com

 * @version 1.1.2

 * @url http://upstatement.com/blog/2012/01/jquery-local-storage-done-right-and-easy/

 */

(function($){var ls=window.localStorage;var supported;if(typeof ls=='undefined'||typeof window.JSON=='undefined'){supported=false;}else{supported=true;}

$.totalStorage=function(key,value,options){return $.totalStorage.impl.init(key,value);}

$.totalStorage.setItem=function(key,value){return $.totalStorage.impl.setItem(key,value);}

$.totalStorage.getItem=function(key){return $.totalStorage.impl.getItem(key);}

$.totalStorage.getAll=function(){return $.totalStorage.impl.getAll();}

$.totalStorage.deleteItem=function(key){return $.totalStorage.impl.deleteItem(key);}

$.totalStorage.impl={init:function(key,value){if(typeof value!='undefined'){return this.setItem(key,value);}else{return this.getItem(key);}},setItem:function(key,value){if(!supported){try{$.cookie(key,value);return value;}catch(e){console.log('Local Storage not supported by this browser. Install the cookie plugin on your site to take advantage of the same functionality. You can get it at https://github.com/carhartl/jquery-cookie');}}

var saver=JSON.stringify(value);ls.setItem(key,saver);return this.parseResult(saver);},getItem:function(key){if(!supported){try{return this.parseResult($.cookie(key));}catch(e){return null;}}

return this.parseResult(ls.getItem(key));},deleteItem:function(key){if(!supported){try{$.cookie(key,null);return true;}catch(e){return false;}}

ls.removeItem(key);return true;},getAll:function(){var items=new Array();if(!supported){try{var pairs=document.cookie.split(";");for(var i=0;i<pairs.length;i++){var pair=pairs[i].split('=');var key=pair[0];items.push({key:key,value:this.parseResult($.cookie(key))});}}catch(e){return null;}}else{for(var i in ls){if(i.length){items.push({key:i,value:this.parseResult(ls.getItem(i))});}}}

return items;},parseResult:function(res){var ret;try{ret=JSON.parse(res);if(ret=='true'){ret=true;}

if(ret=='false'){ret=false;}

if(parseFloat(ret)==ret&&typeof ret!="object"){ret=parseFloat(ret);}}catch(e){}

return ret;}}})(jQuery);





function getStorageAvailable() {

	var test = 'foo';

	var storage =  window.localStorage || window.sessionStorage;

	try {

		storage.setItem(test, test);

		storage.removeItem(test);

		return storage;

	}

	catch (error) {

		return null;

	}

}


$(document).ready(function(){

	var page_name = prestashop.page.page_name;

	if (typeof page_name != 'undefined' && page_name != 'index' && page_name != 'product')
	{

		prestashop.bindGrid();

	}

});



prestashop.bindGrid = function()

{

	var storage = false;

	if (typeof(getStorageAvailable) !== 'undefined') {

		storage = getStorageAvailable();

	}

	if (!storage) {

		return;

	}



	var view = $.totalStorage('display');



	if (!view && (typeof displayList != 'undefined') && displayList)

		view = 'list';



	if (view && view != 'grid')

		prestashop.displayType(view);

	else

		$('.display').find('.show_grid').addClass('selected');



	$(document).on('click', '.show_grid', function(e){

		e.preventDefault();

		if($('#js-product-list .products').hasClass('grid')) {
			return;
		}

		prestashop.displayType('grid');

	});



	$(document).on('click', '.show_list', function(e){

		e.preventDefault();

		if($('#js-product-list .products').hasClass('list')) {
			return;
		}

		prestashop.displayType('list');

	});

}



prestashop.displayType = function(view)

{

	if (view == 'list')

	{

		$('.products').removeClass('grid').addClass('list');

		$('.products article').each(function(index, element) {

			$(element).removeClass('col-xxl-3 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-6').addClass('col-xs-12');

			var html = '';
			html += '<div class="thumbnail-container">';
			html += '<div class="row">';
			html += '<div class="left-block list-block">';
			html += `<div class='product-img-container'>${$(element).find('.product-img-container').html()}</div>`;
			html += `<ul class='product-flags'>${$(element).find('.product-flags').html()}</ul>`;
			html += '</div>';
			html += '<div class="right-block">';
			html += '<div class="row">';
			html += '<div class="col-lg-6 col-md-12 right-list-block">';
			html += `<h1 class="h3 product-title">${$(element).find('.product-title').html()}</h1>`;
			html += `<span class="product-short">${$(element).find('.product-short').html()}</span>`;
			html += '</div>';
			html += '<div class="col-lg-6 col-md-12 right-list-block">';
			html += `<div class='product-price-and-shipping'>${$(element).find('.product-price-and-shipping').html()}</div>`;
			html += `<div class='add-to-cart-btn'>${$(element).find('.add-to-cart-btn').html()}</div>`;
			html += '</div>';
			html += '</div>';
			html += '</div>';
			html += '</div>';//row close
			html += '</div>';//thumbnail close

			$(element).html(html);

		});



		$('.show_list').addClass('selected');

		$('.show_grid').removeClass('selected');

		$.totalStorage('display', 'list');

	}

	else

	{


		$('.products').removeClass('list').addClass('grid');

		$('.products article').each(function(index, element) {


			$(element).removeClass('col-xs-12').addClass('col-xxl-3 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-6');

			var html = '';
			html += '<div class="thumbnail-container">';
			html += '<div class="product-img-container">';
			var left_block = $(element).find('.product-img-container');
			html += left_block.html();
			html += '</div>';
			html += '<div class="product-description">';
			html += `<h1 class="h3 product-title">${$(element).find('.product-title').html()}</h1>`;
			html += '<div class="product-short">';
			html += $(element).find('.product-short').html();
			html += '</div>';
			html += `<div class='product-price-and-shipping'>${$(element).find('.product-price-and-shipping').html()}</div>`;
			html += `<ul class='product-flags'>${$(element).find('.product-flags').html()}</ul>`;
			html += `<div class='add-to-cart-btn'>${$(element).find('.add-to-cart-btn').html()}</div>`;
			html += '</div>';
			html += '</div>';

			$(element).html(html);

		});



		$('.show_grid').addClass('selected');

		$('.show_list').removeClass('selected');

		$.totalStorage('display', 'grid');

	}

	if(typeof prepareBlockLayeredAfterPLA !== 'undefined') {		prepareBlockLayeredAfterPLA();	}

}
